<mat-toolbar class="p-0 mat-elevation-z1">
    <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">
        <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
            @if (!hiddenNavbar && !rightNavbar) {
                <button mat-icon-button class="navbar-toggle-button" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
                    <mat-icon class="secondary-text">menu</mat-icon>
                </button>
            }

            @if (!hiddenNavbar && !rightNavbar) {
                <div class="toolbar-separator" fxHide.gt-md></div>
            }

            <!-- Project selection -->
            <mat-select class="project-selector" placeholder="Select Project" [(ngModel)]="sessionService.currentProject" name="project">
                @for (project of userProjects; track project.id) {
                    <mat-option [value]="project.id">
                        {{ project.name }}
                    </mat-option>
                }
            </mat-select>

            @if (horizontalNavbar) {
                <div fxLayout="row" fxLayoutAlign="start center">
                    <div class="logo ml-16">
                        <img class="logo-icon" src="assets/images/logos/fuse.svg" />
                    </div>
                </div>
            }
        </div>

        <!-- right -->

        <div class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">
            <button
                mat-icon-button
                class="help-button"
                type="button"
                (click)="openHelp()"
                [attr.aria-label]="'TOOLBAR.Help' | translate"
                [title]="'TOOLBAR.Help' | translate"
            >
                <mat-icon>help_outline</mat-icon>
            </button>

            <button
                mat-icon-button
                class="notification-button"
                [class.notification-button--enabled]="browserNotificationsEnabledForThisBrowser"
                [class.notification-button--muted]="browserNotificationsDisabledForCurrentProject"
                (click)="openBrowserNotifications()"
                aria-label="Browser notifications"
            >
                <mat-icon>{{ browserNotificationIcon }}</mat-icon>
                @if (showBrowserNotificationAttention) {
                    <span class="notification-button__badge" aria-hidden="true"></span>
                }
            </button>

            <button mat-button [matMenuTriggerFor]="userMenu" class="user-button">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <img class="avatar mr-0 mr-sm-16" src="assets/images/sample-user.png" />
                    @if (user) {
                        <span class="username mr-12" fxHide fxShow.gt-sm>{{ user.name }}</span>
                    }
                    <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>
                </div>
            </button>

            <mat-menu #userMenu="matMenu" [overlapTrigger]="false">
                <button mat-menu-item class="" (click)="logout()">
                    <mat-icon>exit_to_app</mat-icon>
                    <span>Logout</span>
                </button>
            </mat-menu>

            <div class="toolbar-separator mb-hidden"></div>

            <button mat-button fxHide fxShow.gt-xs class="language-button" [matMenuTriggerFor]="languageMenu">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <img class="flag mr-8" [src]="'assets/images/flags/' + selectedLanguage.flag + '.png'" />
                    <span class="iso text-uppercase">{{ selectedLanguage.id }}</span>
                </div>
            </button>

            <mat-menu #languageMenu="matMenu" [overlapTrigger]="false">
                @for (lang of languages; track lang.id) {
                    <button mat-menu-item (click)="setLanguage(lang)">
                        <span fxLayout="row" fxLayoutAlign="start center">
                            <img class="flag mr-16" [src]="'assets/images/flags/' + lang.flag + '.png'" />
                            <span class="iso">{{ lang.title }}</span>
                        </span>
                    </button>
                }
            </mat-menu>

            @if (!hiddenNavbar && rightNavbar) {
                <div class="toolbar-separator" fxHide fxShow.gt-xs></div>
            }

            @if (!hiddenNavbar && rightNavbar) {
                <button mat-icon-button class="navbar-toggle-button" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
                    <mat-icon class="secondary-text">menu</mat-icon>
                </button>
            }
        </div>
    </div>
</mat-toolbar>
